
const digest = '306b0c19352e9d590609fcafae6bc02f0f01c5defc118ffcbbea14af4f78738f';
const classes = {"wrapper":"_wrapper_1spnc_1","item":"_item_1spnc_7","subItem":"_subItem_1spnc_7","title":"_title_1spnc_12","title2":"_title2_1spnc_15","text":"_text_1spnc_18","textFramed":"_textFramed_1spnc_22","textSubtitle":"_textSubtitle_1spnc_30","textListItem":"_textListItem_1spnc_35","description":"_description_1spnc_50","possibleAnswers":"_possibleAnswers_1spnc_54","note":"_note_1spnc_60","scaleListItem":"_scaleListItem_1spnc_65","radioList":"_radioList_1spnc_72","radioItem":"_radioItem_1spnc_77","radio":"_radio_1spnc_72","colorSphere":"_colorSphere_1spnc_93","addQuestions":"_addQuestions_1spnc_99","addQuestionsWrapper":"_addQuestionsWrapper_1spnc_104","addAlert":"_addAlert_1spnc_108","addAlertWrapper":"_addAlertWrapper_1spnc_113","addAlertItem":"_addAlertItem_1spnc_117","addWarning":"_addWarning_1spnc_125","addWarningWrapper":"_addWarningWrapper_1spnc_130","addWarningItem":"_addWarningItem_1spnc_134","label":"_label_1spnc_142","collapse":"_collapse_1spnc_147","collapseTitle":"_collapseTitle_1spnc_150","collapseContent":"_collapseContent_1spnc_162"};
const css = `._wrapper_1spnc_1 {
  font-family: Rubik, "sans-serif";
  display: flex;
  flex-direction: column;
  gap: 20px;
}
._wrapper_1spnc_1 ._item_1spnc_7 ._subItem_1spnc_7 {
  padding: 5px 20px;
  border-left: 1px solid #e9e9e9;
  margin-left: 13px;
}
._wrapper_1spnc_1 ._item_1spnc_7 ._title_1spnc_12 {
  font-weight: 600;
}
._wrapper_1spnc_1 ._item_1spnc_7 ._title2_1spnc_15 {
  font-size: 14px;
}
._wrapper_1spnc_1 ._item_1spnc_7 ._text_1spnc_18 {
  font-size: 14px;
  padding: 5px 0;
}
._wrapper_1spnc_1 ._item_1spnc_7 ._textFramed_1spnc_22 {
  font-size: 14px;
  padding: 10px 15px;
  background-color: #f3f3f3;
  font-weight: 500;
  width: fit-content;
  margin: 5px 0;
}
._wrapper_1spnc_1 ._item_1spnc_7 ._textSubtitle_1spnc_30 {
  font-size: 14px;
  font-weight: 500;
  padding: 5px 0;
}
._wrapper_1spnc_1 ._item_1spnc_7 ._textListItem_1spnc_35 {
  font-size: 14px;
  padding: 5px 0 5px 25px;
  position: relative;
}
._wrapper_1spnc_1 ._item_1spnc_7 ._textListItem_1spnc_35:before {
  content: "";
  width: 15px;
  height: 1px;
  background: #212357;
  display: block;
  position: absolute;
  left: 0;
  top: 15px;
}
._wrapper_1spnc_1 ._item_1spnc_7 ._description_1spnc_50 {
  color: #6f6f6f;
  font-size: 14px;
}
._wrapper_1spnc_1 ._item_1spnc_7 ._possibleAnswers_1spnc_54 {
  font-size: 14px;
  font-weight: 600;
  margin: 10px 0;
  color: #1665d8;
}
._wrapper_1spnc_1 ._item_1spnc_7 ._possibleAnswers_1spnc_54 ._note_1spnc_60 {
  font-size: 12px;
  color: #6f6f6f;
  font-weight: 400;
}
._wrapper_1spnc_1 ._item_1spnc_7 ._scaleListItem_1spnc_65 {
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
}
._wrapper_1spnc_1 ._item_1spnc_7 ._radioList_1spnc_72 {
  display: flex;
  flex-direction: column;
  gap: 5px;
}
._wrapper_1spnc_1 ._item_1spnc_7 ._radioList_1spnc_72 ._radioItem_1spnc_77 {
  display: flex;
  flex-direction: row;
}
._wrapper_1spnc_1 ._item_1spnc_7 ._radioList_1spnc_72 ._radioItem_1spnc_77 ._radio_1spnc_72 {
  width: 25px;
  height: 25px;
  background: url("/dist/icons/react/radio-default.svg") no-repeat center;
  background-size: contain;
  margin-right: 7.5px;
  cursor: pointer;
}
._wrapper_1spnc_1 ._item_1spnc_7 ._radioList_1spnc_72 ._radioItem_1spnc_77 ._title_1spnc_12 {
  font-size: 14px;
  font-weight: 500;
}
._wrapper_1spnc_1 ._item_1spnc_7 ._radioList_1spnc_72 ._radioItem_1spnc_77 ._colorSphere_1spnc_93 {
  height: 15px;
  width: 15px;
  border-radius: 100%;
  margin-left: 10px;
}
._wrapper_1spnc_1 ._item_1spnc_7 ._addQuestions_1spnc_99 {
  margin-bottom: 10px;
  color: #6a389c;
  font-size: 14px;
}
._wrapper_1spnc_1 ._item_1spnc_7 ._addQuestionsWrapper_1spnc_104 {
  border-left: 1px solid #d3b4f1;
  padding-left: 20px;
}
._wrapper_1spnc_1 ._item_1spnc_7 ._addAlert_1spnc_108 {
  margin-bottom: 10px;
  color: #a83535;
  font-size: 14px;
}
._wrapper_1spnc_1 ._item_1spnc_7 ._addAlertWrapper_1spnc_113 {
  border-left: 1px solid #f1b4b4;
  padding-left: 20px;
}
._wrapper_1spnc_1 ._item_1spnc_7 ._addAlertWrapper_1spnc_113 ._addAlertItem_1spnc_117 {
  font-size: 14px;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;
  color: #000000;
}
._wrapper_1spnc_1 ._item_1spnc_7 ._addWarning_1spnc_125 {
  margin-bottom: 10px;
  color: #db8725;
  font-size: 14px;
}
._wrapper_1spnc_1 ._item_1spnc_7 ._addWarningWrapper_1spnc_130 {
  border-left: 1px solid #e1c79a;
  padding-left: 20px;
}
._wrapper_1spnc_1 ._item_1spnc_7 ._addWarningWrapper_1spnc_130 ._addWarningItem_1spnc_134 {
  font-size: 14px;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;
  color: #000000;
}
._wrapper_1spnc_1 ._item_1spnc_7 ._label_1spnc_142 {
  color: #000;
  font-size: 14px;
  margin-top: 10px;
}
._wrapper_1spnc_1 ._item_1spnc_7 ._collapse_1spnc_147 {
  margin-bottom: 10px;
}
._wrapper_1spnc_1 ._item_1spnc_7 ._collapse_1spnc_147 ._collapseTitle_1spnc_150 {
  background-image: url("/dist/icons/chevron-blue-down.svg");
  font-size: 14px;
  padding: 10px 45px 10px 15px;
  background-color: #f3f3f3;
  font-weight: 500;
  width: fit-content;
  margin: 5px 0;
  background-repeat: no-repeat;
  background-position: right 10px center;
  background-size: 17px;
}
._wrapper_1spnc_1 ._item_1spnc_7 ._collapse_1spnc_147 ._collapseContent_1spnc_162 {
  border-left: 1px solid #e9e9e9;
  padding-left: 20px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  